import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Alert,
  Snackbar,
} from "@mui/material";
import style from "../../../../styles/brsr/general.module.css";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const LeadershipIndicatorsForm = ({ onSave, hide, removeUpload = false }) => {
  // const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [formData1, setFormData1] = useState({});
  const [modalupload, setModalUpload] = useState({
    stakeholderConsultationProcessesDoc: false,
    stakeholderConsultationIntegrationDoc: false,
    vulnerableStakeholderEngagementDoc: false,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    stakeholderConsultationProcesses: "",
    stakeholderConsultationIntegration: {
      action: true,
      remark: "",
    },
    vulnerableStakeholderEngagement: "",
  });

  const [errors, setErrors] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const type = "SectionC";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `${api}/brsr/get?subType=principle4&type=${type}&id=${id}`
        );
        if (
          response?.data?.data?.year
            ? response?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);

        // Updated check for leadershipIndicator
        if (
          response &&
          response.data &&
          response.data.data.BRSRSectionC &&
          response.data.data.BRSRSectionC.principle4.leadershipIndicator
        ) {
          const leadershipIndicator =
            response.data.data.BRSRSectionC.principle4.leadershipIndicator;
          setFormData1(leadershipIndicator);
          // Set the form data with the necessary values
          setFormData({
            stakeholderConsultationProcesses:
              leadershipIndicator.stakeholderConsultationProcesses ?? "",
            stakeholderConsultationIntegration: {
              action:
                leadershipIndicator.stakeholderConsultationIntegration
                  ?.action ?? false,
              remark:
                leadershipIndicator.stakeholderConsultationIntegration
                  ?.remark ?? "",
            },
            vulnerableStakeholderEngagement:
              leadershipIndicator.vulnerableStakeholderEngagement ?? "",
          });
        } else {
          console.error("Leadership Indicator data is not available.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [id, type]);

  const handleChange = (field, value) => {
    setErrors((prev) => ({
      ...prev,
      [field]: value.trim() ? "" : prev[field],
    }));

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleNestedChange = (field, nestedField, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        [nestedField]: value,
      },
    }));

    if (nestedField === "remark" && value.trim()) {
      setErrors((prev) => ({
        ...prev,
        stakeholderConsultationIntegration: "",
      }));
    }
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // Validation
      const newErrors = {};

      // if (
      //   !formData.stakeholderConsultationProcesses ||
      //   typeof formData.stakeholderConsultationProcesses !== "string" ||
      //   !formData.stakeholderConsultationProcesses.trim()
      // ) {
      //   newErrors.stakeholderConsultationProcesses = "This field is required.";
      // }

      if (
        formData.stakeholderConsultationIntegration.action &&
        (!formData.stakeholderConsultationIntegration.remark ||
          typeof formData.stakeholderConsultationIntegration.remark !==
            "string" ||
          !formData.stakeholderConsultationIntegration.remark.trim())
      ) {
        newErrors.stakeholderConsultationIntegration =
          "Please provide details if action is selected.";
      }

      // if (
      //   !formData.vulnerableStakeholderEngagement ||
      //   typeof formData.vulnerableStakeholderEngagement !== "string" ||
      //   !formData.vulnerableStakeholderEngagement.trim()
      // ) {
      //   newErrors.vulnerableStakeholderEngagement = "This field is required.";
      // }

      setErrors(newErrors);

      if (Object.keys(newErrors).length > 0) return;
      // API Call
      try {
        const payload = {
          leadershipIndicator: {
            ...formData,
            ...formData1,
          },
          leadershipIndicatorSubmitted: true,
          type: "SectionC",
          subType: "principle4",
        };

        const response = await put(`/brsr/update?id=${id}`, payload);
        setsnackOpen({
          open: true,
          message: "Data saved successfully!",
          severity: "success",
        });
        navigate(`/brsr/section-c/principle5/${id}`);
        if (onSave) onSave(response.data);
      } catch (error) {
        console.error(error);
        setsnackOpen({
          open: true,
          message: "Failed to save data. Please try again.",
          severity: "error",
        });
      }
    } else navigate(`/brsr/section-c/principle5/${id}`);
  };

  return (
    <Box>
      <p className={style.subHeading}>II. LEADERSHIP INDICATOR</p>

      {/* 1. Stakeholder Consultation Processes */}
      <Box mb={4}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            textIndent: "-1rem",
            paddingLeft: "0.9rem",
          }}
          gutterBottom
        >
          1. Provide the processes for consultation between stakeholders and the
          Board on economic, environmental, and social topics or if consultation
          is delegated, how is feedback from such consultations provided to the
          Board.
        </Typography>
        <TextField
          fullWidth
          disabled={disabled}
          multiline
          rows={3}
          sx={{ marginLeft: "0.9rem", width: "99%" }}
          placeholder="Type Here"
          value={formData.stakeholderConsultationProcesses}
          onChange={(e) =>
            handleChange("stakeholderConsultationProcesses", e.target.value)
          }
          error={!!errors.stakeholderConsultationProcesses}
          helperText={
            <Typography
              variant="body2"
              color="error"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginLeft: "-10px",
              }}
            >
              {errors.stakeholderConsultationProcesses}
            </Typography>
          }
        />
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "stakeholderConsultationProcessesDoc",
          ml: 2,
          mt: "-1.6rem",
          removeUpload,
        }}
      />

      {/* 2. Stakeholder Consultation Integration */}
      <Box mb={4}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            mt: 2,
            textIndent: "-1rem",
            paddingLeft: "0.9rem",
          }}
          gutterBottom
        >
          2. Whether stakeholder consultation is used to support the
          identification and management of environmental, and social topics (Yes
          / No). If so, provide details of instances as to how the inputs
          received from stakeholders on these topics were incorporated into
          policies and activities of the entity.
        </Typography>
        <RadioGroup
          disabled={disabled}
          row
          value={formData.stakeholderConsultationIntegration.action}
          sx={{ marginLeft: "0.9rem", width: "99%" }}
          onChange={(e) =>
            handleNestedChange(
              "stakeholderConsultationIntegration",
              "action",
              e.target.value === "true"
            )
          }
        >
          <FormControlLabel
            value={true}
            control={<Radio disabled={disabled} />}
            label="Yes"
          />
          <FormControlLabel
            value={false}
            control={<Radio disabled={disabled} />}
            label="No"
          />
        </RadioGroup>
        {formData.stakeholderConsultationIntegration.action && (
          <TextField
            fullWidth
            disabled={disabled}
            multiline
            rows={3}
            sx={{ marginLeft: "0.9rem", width: "99%" }}
            placeholder="Type Here"
            value={formData.stakeholderConsultationIntegration.remark}
            onChange={(e) =>
              handleNestedChange(
                "stakeholderConsultationIntegration",
                "remark",
                e.target.value
              )
            }
            error={!!errors.stakeholderConsultationIntegration}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-10px",
                }}
              >
                {errors.stakeholderConsultationIntegration}
              </Typography>
            }
          />
        )}
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "stakeholderConsultationIntegrationDoc",
          ml: 2,
          mt: "-1.6rem",
          removeUpload,
        }}
      />

      {/* 3. Vulnerable Stakeholder Engagement */}
      <Box mb={4}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            mt: 2,
            textIndent: "-1rem",
            paddingLeft: "0.9rem",
          }}
          gutterBottom
        >
          3. Provide details of instances of engagement with, and actions taken
          to, address the concerns of vulnerable/ marginalized stakeholder
          groups.
        </Typography>
        <TextField
          disabled={disabled}
          fullWidth
          multiline
          rows={3}
          sx={{ marginLeft: "0.9rem", width: "99%" }}
          placeholder="Type Here"
          value={formData.vulnerableStakeholderEngagement}
          onChange={(e) =>
            handleChange("vulnerableStakeholderEngagement", e.target.value)
          }
          error={!!errors.vulnerableStakeholderEngagement}
          helperText={
            <Typography
              variant="body2"
              color="error"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginLeft: "-10px",
              }}
            >
              {errors.vulnerableStakeholderEngagement}
            </Typography>
          }
        />
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "vulnerableStakeholderEngagementDoc",
          ml: 2,
          mt: "-1.6rem",
          removeUpload,
        }}
      />

      {/* Submit Button */}
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1rem", width: "98%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
                onClick={handleSubmit}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity || "info"} // Ensure a default severity if undefined
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message || "No message provided"}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LeadershipIndicatorsForm;
